import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useState, useRef } from "react";
import { Menu, Typography } from "@mui/material";
import { CallOpen } from "../../../../assets/icons/CallOpen.js";
import { Voicemail } from "../../../../assets/icons/Voicemail.js";
import { DataTestIds } from "../../../../call-management.constants.js";
import { StyledMenuItem } from "../CallCardName/CallCardName.styles.js";
import { StyledIconButton, StatusMenuIcon } from "./CallCardVoicemail.styles.js";
import "date-fns";
import "@mui/material/styles";
import "../../../../call-management.types.js";
const CallCardVoicemail = ({ status, phones, onSelect }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const voicemailButtonRef = useRef(null);
  const handleButtonClick = (event) => {
    event.stopPropagation();
    setAnchorEl((prevState) => prevState ? null : event.currentTarget);
  };
  const handleClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };
  const handleVoicemailMenuItemClick = (value) => (event) => {
    event.stopPropagation();
    onSelect(value);
    setAnchorEl(null);
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      StyledIconButton,
      {
        status,
        "data-testid": DataTestIds.CallCardVoicemail,
        onClick: handleButtonClick,
        ref: voicemailButtonRef,
        children: /* @__PURE__ */ jsx(Voicemail, {})
      }
    ),
    /* @__PURE__ */ jsx(
      Menu,
      {
        id: "voicemail-available-phones",
        "data-testid": DataTestIds.CallCardVoicemailList,
        anchorEl,
        open: !!anchorEl,
        keepMounted: true,
        onClose: handleClose,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "right"
        },
        children: phones == null ? void 0 : phones.filter((phone) => phone).map((phone) => /* @__PURE__ */ jsxs(StyledMenuItem, { disableRipple: true, onClick: handleVoicemailMenuItemClick(phone), children: [
          /* @__PURE__ */ jsx(StatusMenuIcon, { children: /* @__PURE__ */ jsx(CallOpen, {}) }),
          /* @__PURE__ */ jsx(Typography, { variant: "Lato Caption Bold", children: phone.name })
        ] }, phone.referenceId))
      }
    )
  ] });
};
export {
  CallCardVoicemail
};
